import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
// import MyReactSelect from '../input/MyReactSelect'
import SuggestingSelector from '../input/SuggestingSelector'
import MyReactInput from '../input/MyReactInput'

export default function CharacterSelect (props) {
  const [value, setValue] = useState(props.characterId || props.characters[0].id)
  const [isFree, setIsFree] = useState(false)

  const characters = [{ id: -1, title: '選択してください' }]
  const groupMap = new Map(props.groups.map(group => [group.id, group.group_name]))
  const defaultCharacters = []
  props.characters.forEach((character) => {
    if (character.is_default) {
      character.title = 'その他' + (props.isShopro ? `（${groupMap.get(character.group_id)}）` : '')
      defaultCharacters.push(character)
    } else {
      characters.push(character)
    }
  })
  characters.push(...defaultCharacters)

  useEffect(() => {
    const idx = characters.findIndex((character) => character.id === props.characterId)
    if (idx > -1) {
      setIsFree(characters[idx].is_default)
    }
  }, [])

  useEffect(() => {
    // オプションが設定されている場合、承認ボタンを探して選択状況に応じてdisabledを切り替える
    if (props.disableApproveWhenFree) {
      $('button.open-wf-approve-modal').each((i, el) => {
        $(el).attr('disabled', isFree)
        $(el).attr('title', isFree ? 'キャラクター「その他」の状態で承認することはできません。' : '')
      })
    }
  }, [isFree])

  return (
    <>
      <div className="my-input-root">
        <SuggestingSelector
          objects={characters}
          value={value}
          propertyName="title"
          word={''}
          readonly={props.readonly}
          required={true}
          label={'キャラクター'}
          name={'character_id'}
          options={{
            onChange: (e, val) => {
              setValue(val ? val.id : 0)
              setIsFree(val ? val.is_default : false)

              if (val) {
                const url = new URL(location)
                url.searchParams.set('character_id', val.id !== -1 ? val.id : null)
                if (props.jumpHash !== '') {
                  url.hash = props.jumpHash
                }
                location.href = url.href
              }
            },
            disableClearable: true,
            error: props.errors.character_id
          }}
        />
      </div>
      <div className={isFree ? 'my-input-root' : 'd-none'}>
        <MyReactInput
          labelText="キャラクター名（自由入力）"
          inputProps={{
            name: 'character_name_free',
            type: 'text',
            value: props.characterNameFree || '',
            readonly: props.readonly,
            disabled: !isFree,
            required: isFree,
            error: Boolean(props.errors.character_name_free),
            helperText: props.errors.character_name_free,
            maxlength: 100
          }}
        />
      </div>
    </>
  )
}

CharacterSelect.propTypes = {
  characters: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
  characterId: PropTypes.number,
  characterNameFree: PropTypes.string,
  errors: PropTypes.object,
  readonly: PropTypes.bool,
  jumpHash: PropTypes.string,
  disableApproveWhenFree: PropTypes.bool,
  isShopro: PropTypes.bool
}

CharacterSelect.defaultProps = {
  jumpHash: '',
  disableApproveWhenFree: false,
  isShopro: false
}

$('.character-select').each((i, elem) => {
  const props = $(elem).data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(<CharacterSelect {...props}/>, elem)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    $(elem).removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
